import { render, staticRenderFns } from "./plan_chart.vue?vue&type=template&id=64a5f9c2&"
import script from "./plan_chart.vue?vue&type=script&lang=js&"
export * from "./plan_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports